import React from "react";
import { ChatHelper } from "../helpers";
import { ChatMessage, LiveChatData, ScreenType } from "../types";
import { getInfoMessage } from "../utils/language";

type MessageLiveChatProps = {
  chatHelper?: ChatHelper | null | undefined;
  chatData?: LiveChatData | null | undefined;
  screenType?: ScreenType;
  message: ChatMessage;
};

const MessageLiveChat: React.FC<MessageLiveChatProps> = ({
  chatHelper,
  chatData,
  screenType,
  message,
}) => {
  if (!chatHelper) {
    return null;
  }

  if (chatHelper.showLiveChatBar(message.id)) {
    return (
      <div className="chatyme-message-item chatyme-live-chat-border">
        <div className="chatyme-live-chat-text chatyme-live-chat-start">
          {getInfoMessage('liveChatStarted', chatData, screenType)}
        </div>
      </div>
    );
  }

  if (chatHelper.showWaitingForAgentBar(message.id)) {
    return (
      <div className="chatyme-message-item chatyme-live-chat-border">
        <div className="chatyme-live-chat-text chatyme-live-chat-waiting">
          {getInfoMessage('waitingForAgent', chatData, screenType)}
        </div>
      </div>
    );
  }

  return null;
};

export default MessageLiveChat;